import './main.css';
import Layout from 'utils/layout';
import Video from 'utils/video';
import productOption from 'utils/product-option';
import './utils/dropdown';
import './utils/select-menu';
import './utils/product-form';
import './utils/add-to-cart-button';
import './cart/cart';
import './utils/quantity-input';
import './utils/modal-dialog';
import './utils/colors';
import './bundle/bundle-products';
import { register } from 'swiper/element/bundle';
import Stickers from 'utils/stickers';

register();
productOption();
// eslint-disable-next-line no-new
new Stickers();

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`).then((m) => {
      const module = m.default;
      const { webcomponent } = m;
      const modules = [...sections].filter(
        (section) => section.dataset.section === name,
      );
      modules.forEach((element) => {
        const dataEl = element.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = element.querySelectorAll('[data-component="video"]');
        const videos =
          videoEls &&
          [...videoEls].map(
            (videoEl) => new Video({ element, video: videoEl, layout }),
          );

        if (!webcomponent && typeof module === 'function') {
          module(element, { ...data, layout, videos });
        } else if (webcomponent && typeof module === 'function') {
          if (!customElements.get(webcomponent)) {
            customElements.define(webcomponent, module);
          }
        } else {
          // eslint-disable-next-line no-console
          console.warn(
            // eslint-disable-next-line max-len
            `Module for ${name} does not have a default export or a webcomponent export`,
          );
        }
      });
    });
  });
})();
